// import _get from 'lodash/get'
export function mounted() {
  this.updateRows()
}
